import { render, staticRenderFns } from "./GlButton.vue?vue&type=template&id=43f61270&scoped=true&"
import script from "./GlButton.vue?vue&type=script&lang=js&"
export * from "./GlButton.vue?vue&type=script&lang=js&"
import style0 from "./GlButton.vue?vue&type=style&index=0&id=43f61270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f61270",
  null
  
)

export default component.exports